// extracted by mini-css-extract-plugin
export default {"overDue":"VehicleDue_overDue__qJKFJ"};